/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_User_Not_FoundInputs */

const en_login_error_user_not_found = /** @type {(inputs: Login_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No account found with this email address.`)
};

const fr_login_error_user_not_found = /** @type {(inputs: Login_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun compte trouvé avec cette adresse email.`)
};

const de_login_error_user_not_found = /** @type {(inputs: Login_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurde kein Konto mit dieser E-Mail-Adresse gefunden.`)
};

const it_login_error_user_not_found = /** @type {(inputs: Login_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun account trovato con questo indirizzo email.`)
};

const ru_login_error_user_not_found = /** @type {(inputs: Login_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учетная запись с этим адресом электронной почты не найдена.`)
};

const es_login_error_user_not_found = /** @type {(inputs: Login_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró ninguna cuenta con esta dirección de correo electrónico.`)
};

const zh_cn2_login_error_user_not_found = /** @type {(inputs: Login_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到与此电子邮件地址关联的帐户。`)
};

const ja_login_error_user_not_found = /** @type {(inputs: Login_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このメールアドレスに該当するアカウントは見つかりません。`)
};

const hi_login_error_user_not_found = /** @type {(inputs: Login_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ईमेल पते से कोई खाता नहीं मिला।`)
};

const pt_pt2_login_error_user_not_found = /** @type {(inputs: Login_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conta encontrada com este endereço de e-mail.`)
};

/**
* | output |
* | --- |
* | "No account found with this email address." |
*
* @param {Login_Error_User_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_user_not_found = /** @type {((inputs?: Login_Error_User_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_User_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_user_not_found(inputs)
	if (locale === "de") return de_login_error_user_not_found(inputs)
	if (locale === "it") return it_login_error_user_not_found(inputs)
	if (locale === "ru") return ru_login_error_user_not_found(inputs)
	if (locale === "es") return es_login_error_user_not_found(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_user_not_found(inputs)
	if (locale === "ja") return ja_login_error_user_not_found(inputs)
	if (locale === "hi") return hi_login_error_user_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_user_not_found(inputs)
	return en_login_error_user_not_found(inputs)
});